import containerOrderingData from '../data/containerOrder.json';
import { WorkInstructions } from '../WorkInstructions';

export const ContainerOrder = () => {
    const nav = [
        { name: 'Home', path: '/home/viewQuote' },
        { name: 'Support', path: '/home/support' },
        { name: 'Container Ordering', path: '/home/support/container-ordering' },
    ];

    return <WorkInstructions title="Container Ordering" nav={nav} sections={containerOrderingData} />;
};
